import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
@Component({
  selector: 'gregorian-date-picker',
  templateUrl: './gregorian-date-picker.component.html',
  styleUrls: ['./gregorian-date-picker.component.scss'],
})
export class GregorianDatePickerComponent implements OnInit {
  model: NgbDateStruct = {} as NgbDateStruct;
  @Input() set date(value: string) {
    this._date = value;
  }
  get date(): string {
    return this._date;
  }
  _date: string = null;
  private gregorianDate: any;
  @Input() disable: boolean = false;
  @Output() dateChange: EventEmitter<string> = new EventEmitter<string>();
  constructor(private calendar: NgbCalendar) {
    moment.locale('en-US');
  }
  selectToday() {
    this.model = this.calendar.getToday();
  }

  ngOnInit() {
    if (this.date) {
      this.gregorianDate = moment(this.date, 'YYYY-MM-DDTHH:mm:ss');
      this.model.day = this.gregorianDate.date();
      this.model.month = this.gregorianDate.month() + 1;
      this.model.year = this.gregorianDate.year();
    } else {
      this.selectToday();
      this.claculateGregorianAndEmmit();
    }
  }
  onDateChange() {
    this.claculateGregorianAndEmmit();
  }
  claculateGregorianAndEmmit() {
    this.gregorianDate = moment({ ...this.model, month: this.model.month - 1 }).format('YYYY-MM-DDTHH:mm:ss');
    this.dateChange.emit(this.gregorianDate);
  }
}
